import React, { useEffect, useRef, useState } from "react";
import { personalInfo } from "../../data/portfolio";
import Icon from "./Icon";

/**
 * The primary action of the ending: copy the address, with a designed readout
 * state instead of a toast. Falls back to opening mail if the clipboard is
 * blocked, so the control is never a dead end.
 */
const CopyEmail = ({ className = "" }) => {
  const [state, setState] = useState("idle"); // idle | copied | failed
  const timer = useRef(0);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(personalInfo.email);
      setState("copied");
    } catch {
      window.location.href = `mailto:${personalInfo.email}`;
      setState("failed");
    }
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setState("idle"), 2400);
  };

  const readout = {
    idle: "",
    copied: "Copied",
    failed: "Opening your mail app",
  }[state];

  return (
    <div className={`flex flex-wrap items-center gap-4 ${className}`}>
      <button
        type="button"
        onClick={copy}
        className="control control-solid"
        data-cursor-label={state === "copied" ? "Copied" : "Copy"}
      >
        {state === "copied" ? "Copied" : "Copy email"}
        <Icon name={state === "copied" ? "check" : "copy"} />
      </button>

      <a href={`mailto:${personalInfo.email}`} className="control" data-cursor-label="Mail">
        Send an email
        <Icon name="mail" />
      </a>

      <span className="t-label" role="status" aria-live="polite">
        {readout}
      </span>
    </div>
  );
};

export default CopyEmail;
